import hoverintent from "hoverintent";

class HoverImage {
    constructor() {
        this.hoverLinks = null;
        this.hoverImages = null;
        this.activeLink;

        this.getElements();
        this.init();
    }

    getElements() {
        this.hoverLinks = document.querySelectorAll('.js-hover-link');
        this.hoverImages = document.querySelectorAll('.js-hover-img');
    }

    init() {
        this.handleIntent();
    }

    handleIntent() {
        if (this.hoverLinks.length > 0 && this.hoverImages.length > 0) {

            this.hoverLinks.forEach((link) => {
                hoverintent(link, (e) => {
                    this.activeLink = link;
                    this.hoverIn(link);
                }, (e) => {
                    this.hoverOut();
                });
            });
        }
    }

    hoverIn() {
        const target = document.querySelector(`[data-trigger=${this.activeLink.dataset.target}]`);
        target.classList.add('is-active');
    }

    hoverOut() {
        this.hoverImages.forEach(img => {
            img.classList.remove('is-active');
        });
    }

}

export function initHoverImage() {
    new HoverImage(); // eslint-disable-line no-new
}
